import React, { createContext, useContext, useState, useEffect } from 'react';

interface TailwindThemeContextType {
  currentTheme: 'light' | 'dark';
  changeCurrentTheme: (theme: 'light' | 'dark') => void;
  toggleTheme: () => void;
}

const TailwindThemeContext = createContext<TailwindThemeContextType>({
  currentTheme: 'light',
  changeCurrentTheme: () => {},
  toggleTheme: () => {},
});

export const useTailwindTheme = () => {
  const context = useContext(TailwindThemeContext);
  if (!context) {
    throw new Error('useTailwindTheme must be used within a TailwindThemeProvider');
  }
  return context;
};

interface TailwindThemeProviderProps {
  children: React.ReactNode;
}

export const TailwindThemeProvider: React.FC<TailwindThemeProviderProps> = ({ children }) => {
  // Tema sempre claro - não pode ser alterado
  const theme: 'light' = 'light';

  const changeCurrentTheme = (newTheme: 'light' | 'dark') => {
    // Não faz nada - tema sempre claro
  };

  const toggleTheme = () => {
    // Não faz nada - tema sempre claro
  };

  useEffect(() => {
    // Sempre aplicar tema claro
    document.documentElement.classList.remove('dark');
    document.documentElement.style.colorScheme = 'light';
  }, []);

  return (
    <TailwindThemeContext.Provider value={{ currentTheme: theme, changeCurrentTheme, toggleTheme }}>
      {children}
    </TailwindThemeContext.Provider>
  );
};

